export enum AppLinks {
  AboutLink = '/',
  SignInLink = '/sign-in',
  SignUpLink = '/sign-up',
  BusinessesLink = '/user/businesses',
  BusinessRegistrationLink = '/user/business/registration',
  BusinessLink = '/user/business/:id',
  PointLink = '/user/point/:id',
  AdministratorLink = '/user/administrator/:id',
  ManagerLink = '/user/manager/:id',
  EmployeeLink = '/user/employee/:id',
  OwnerProfileLink = '/owner/profile',
  CreatePointLink = '/user/business/:id/create-point',
  CreateManagerLink = '/user/business/:id/create-manager',
  CreateEmployeeLink = '/user/point/:id/create-employee',
  PointEmployeeSchedulesLink = '/user/point/:id/employee-schedules',
  CreateAdministratorLink = '/user/business/:id/create-administrator',
  BusinessSettingsLink = '/user/business/:id/settings',
  PointSettingsLink = '/user/point/:id/settings',
  EmailConfirmationLink = '/user/email-confirmation',
  PasswordChangeLink = '/user/password-change/:key/:mail',
  CustomerCreateBookingLink = '/customer/create-booking/:pointId',
  DayCalendarLink = '/user/point/day-calendar',
  PrivacyPolicyLink = '/privacy-policy',
  TermsOfServiceLink = '/terms-of-service',
  CookiePolicyLink = '/cookie-policy',
  LicenseAgreementLink = '/license-agreement',
}
